import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blog/page.tsx");
